"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AbstractSnapRestrictionApi_restriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSnapRestrictionApi = void 0;
class AbstractSnapRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        // #region Properties (1)
        _AbstractSnapRestrictionApi_restriction.set(this, void 0);
        __classPrivateFieldSet(this, _AbstractSnapRestrictionApi_restriction, restriction, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (6)
    get enabled() {
        return __classPrivateFieldGet(this, _AbstractSnapRestrictionApi_restriction, "f").enabled;
    }
    set enabled(value) {
        __classPrivateFieldGet(this, _AbstractSnapRestrictionApi_restriction, "f").enabled = value;
    }
    get enabledEditable() {
        return __classPrivateFieldGet(this, _AbstractSnapRestrictionApi_restriction, "f").enabledEditable;
    }
    get id() {
        return __classPrivateFieldGet(this, _AbstractSnapRestrictionApi_restriction, "f").id;
    }
    get priority() {
        return __classPrivateFieldGet(this, _AbstractSnapRestrictionApi_restriction, "f").priority;
    }
    set priority(value) {
        __classPrivateFieldGet(this, _AbstractSnapRestrictionApi_restriction, "f").priority = value;
    }
}
exports.AbstractSnapRestrictionApi = AbstractSnapRestrictionApi;
_AbstractSnapRestrictionApi_restriction = new WeakMap();
//# sourceMappingURL=AbstractSnapRestrictionApi.js.map